enum OnboardingWizardSteps {
  PREPARE_COMPANY = "PREPARE_COMPANY",
  ADD_EMPLOYEES = "ADD_EMPLOYEES",
  ADD_LOCATIONS = "ADD_LOCATIONS",
  ADD_MANAGERS = "ADD_MANAGERS",
  ASSIGN_EMPLOYEES = "ASSIGN_EMPLOYEES",
}

export default OnboardingWizardSteps;
